module.exports = ".day {\r\n    width: 40px;\r\n}\r\n\r\n.year {\r\n    width: 60px;\r\n}\r\n"